import client from "libs/HttpClient";

/**
 * Service class for handling Cards.
 */
class CardService {
  /**
   * Store Bank Details of a user based on the provided request.
   *
   * @param request - The request parameters for Store Bank Details.
   * @returns A Promise that resolves to the Axios response for the Store Bank Details request.
   */
  static storeBankDetails(request: any) {
    return client.put("admin/card/store-bank-details/", request);
  }

  /**
   * Store Card Details of a user based on the provided request.
   *
   * @param request - The request parameters for Store Card Details.
   * @returns A Promise that resolves to the Axios response for the Store Card Details request.
   */
  static addCardDetails(request: any) {
    return client.put("admin/card/store-card-details/", request);
  }

  /**
   * get Card List based on the provided request.
   *
   * @param request - The request parameters for getting a Card.
   * @returns A Promise that resolves to the Axios response for the update Card request.
   */
  static getCardList(request: any) {
    return client.get("admin/card/get-card-list", request);
  }

  /**
   * get Card List based on the provided request.
   *
   * @param request - The request parameters for getting a Card.
   * @returns A Promise that resolves to the Axios response for the update Card request.
   */
  static getBankList(request: any) {
    return client.get("admin/card/get-bank-list", request);
  }

  /**
   * Deletes a Card based on the provided parameters.
   *
   * @param params - The parameters for deleting the Card.
   * @returns A Promise that resolves to the Axios response for the delete Card request.
   */
  static deleteCard(params: any) {
    return client.delete("/admin/card/delete", { params });
  }

  /**
   * Store Card Details of a user based on the provided request.
   *
   * @param request - The request parameters for Store Card Details.
   * @returns A Promise that resolves to the Axios response for the Store Card Details request.
   */
  static addCardDetailsByUser(request: any) {
    return client.put("admin/card/add-card", request);
  }

  /**
   * Updates the details of a Bank Details based on the provided request.
   *
   * @param request - The request parameters for updating a Bank Details.
   * @returns A Promise that resolves to the Axios response for the update Bank Details request.
   */
  static updateBankDetails(request: any) {
    return client.put("admin/card/edit-bank-details", request);
  }

  /**
   * Store Bank Details of a user based on the provided request.
   *
   * @param request - The request parameters for Store Bank Details.
   * @returns A Promise that resolves to the Axios response for the Store Bank Details request.
   */
  static addBankDetailsByUser(request: any) {
    return client.put("admin/card/add-bank", request);
  }

  /**
   * Set Default Card of a user based on the provided request.
   *
   * @param request - The request parameters for Set Default Card.
   * @returns A Promise that resolves to the Axios response for the Set Default Card request.
   */
  static setDefaultDetails(request: any) {
    return client.put("admin/card/default", request);
  }

  /**
   * get Default Card based on the provided request.
   *
   * @param request - The request parameters for getting a Card.
   * @returns A Promise that resolves to the Axios response for the update Card request.
   */
  static getDefaultCardDetails(request: any) {
    return client.get("admin/card/get-default-card", request);
  }
}

export { CardService };
